function getOrgNameFromOrgId(organizationData, orgId) {
    let orgName;
    organizationData?.organizations.forEach(({ id, name }) => {
        if (id !== orgId) return;
        orgName = name;
    });
    return orgName;
}

export { getOrgNameFromOrgId };
